// jshint esversion: 8
export default {
  SET_ID: (state, id) => state.id = id,
  SET_USERNAME: (state, username) => state.username = username,
  SET_EMAIL: (state, email) => state.email = email,
  SET_FIRST_NAME: (state, first_name) => state.first_name = first_name,
  SET_LAST_NAME: (state, last_name) => state.last_name = last_name,
  SET_IMAGE: (state, image) => state.image = image,
  SET_DEPARTMENT: (state, department) => state.department = department,
  SET_LOCATION: (state, location) => state.location = location
}
